(function () {
  'use strict';

  if (window.__miniVerseMotion) return;
  window.__miniVerseMotion = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var selectors = [
    '.template-index .mv-new__head',
    '.template-index .mv-new__card',
    '.template-index .mv-section-head',
    '.template-index .mv-sale-card',
    '.template-index .mv-weekly__top',
    '.template-index .mv-weekly__card',
    '.template-index .mv-now__head',
    '.template-index .mv-now__card',
    '.template-index [class*="collection-heading-"]',
    '.template-index [class*="collection-item-"]',
    '.template-index [class*="bubble_item-"]',
    '.template-product .mv-related__head',
    '.template-product .mv-related__card'
  ].join(',');

  var observer = !reduceMotion && 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('mv-motion-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 })
    : null;

  function prepare(root) {
    var nodes = [];
    if (root.nodeType === 1 && root.matches(selectors)) nodes.push(root);
    if (root.querySelectorAll) nodes = nodes.concat(Array.from(root.querySelectorAll(selectors)));

    nodes.forEach(function (node) {
      if (node.dataset.mvMotionReady) return;
      node.dataset.mvMotionReady = '1';
      node.classList.add('mv-motion-item');

      var parent = node.parentElement;
      var siblings = parent ? Array.from(parent.children).filter(function (item) {
        return item.matches && item.matches(selectors);
      }) : [];
      var index = Math.max(0, siblings.indexOf(node));
      node.style.setProperty('--mv-motion-delay', Math.min(index, 5) * 65 + 'ms');

      var box = node.getBoundingClientRect();
      if (!observer || box.top < window.innerHeight * 0.88) {
        requestAnimationFrame(function () { node.classList.add('mv-motion-visible'); });
      } else {
        observer.observe(node);
      }
    });
  }

  function start() {
    prepare(document);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) prepare(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    prepare(event.target);
  });
})();
